import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { useTranslation } from 'react-i18next';
import plus from '../../assests/plus.svg';
import eye from '../../assests/eye.svg';
import './invoices.css';

// Print icon component
const PrintIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"/>
  </svg>
);

const Invoices = () => {
  const { t, i18n } = useTranslation();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetchInvoices();
  }, [token, i18n.language]);

  const fetchInvoices = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://naql.nozzm.com/api/invoices', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'lang': i18n.language,
        },
        body: JSON.stringify({}),
      });

      const result = await response.json();
      if (result.status) {
        setInvoices(result.data.data || []);
      } else {
        setError(result.message || 'Failed to fetch invoices');
      }
    } catch (error) {
      setError('Error fetching invoices');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = (invoice) => {
    navigate('/InvoicePrint', { state: { invoice } });
  };

  const handleView = (invoice) => {
    navigate('/InvoiceView', { state: { invoice } });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-SA');
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ar-SA', {
      style: 'currency',
      currency: 'SAR'
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="container tables bg-white mt-5">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container tables bg-white mt-5">
      <div className="tableTitle d-flex justify-content-between">
        <h3>{t('invoices.title')}</h3>
        <Link to="/InvoiceData">
          <button className="btn btn-primary">
            <img src={plus} alt="" />
            <span className="pe-3">{t('invoices.addInvoice')}</span>
          </button>
        </Link>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="table-responsive">
        <table className="table borderless TableDr text-center">
          <thead>
            <tr>
              <th scope="col">{t('invoices.invoiceNumber')}</th>
              <th scope="col">{t('invoices.invoiceDate')}</th>
              <th scope="col">{t('invoices.customerName')}</th>
              <th scope="col">{t('invoices.invoiceType')}</th>
              <th scope="col">{t('invoices.grandTotal')}</th>
              <th scope="col">{t('invoices.paymentMethod')}</th>
              <th scope="col">{t('control')}</th>
            </tr>
          </thead>
          <tbody>
            {invoices.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">
                  لا توجد فواتير
                </td>
              </tr>
            ) : (
              invoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td>{invoice.invoice_number}</td>
                  <td>{formatDate(invoice.invoice_date)}</td>
                  <td>{invoice.customer_name}</td>
                  <td>
                    <span className={`badge ${invoice.type === 'credit_note' ? 'bg-warning' : 'bg-success'}`}>
                      {invoice.type === 'credit_note' ? t('invoices.creditNote') : t('invoices.salesInvoice')}
                    </span>
                  </td>
                  <td>{formatCurrency(invoice.grand_total)}</td>
                  <td>{t(`invoices.${invoice.payment_method}`)}</td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => handleView(invoice)}
                        title={t('edit')}
                      >
                        <img src={eye} alt="View" style={{ width: '16px', height: '16px' }} />
                      </button>
                                             <button
                         className="btn btn-sm btn-outline-secondary"
                         onClick={() => handlePrint(invoice)}
                         title={t('invoices.print')}
                       >
                         <PrintIcon />
                       </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Invoices;
